import React from 'react';
import Helpers from '../helpers';

import { ProductFormContext } from '../../../../context/product-form-context';

const OptionGroupAsSelect = ({
	option,
	index: groupIndex,
	setFilter,
	setFilters,
	filters,
}) => {
	const {
		availabilityMap,
		product,
		showErrors,
	} = React.useContext(ProductFormContext);

	const allOptionValues =	option.values;
	const availableOptionValues = Helpers.getAvailableOptionsWithinSelections(
		product,
		groupIndex,
		filters,
		availabilityMap
	);

	//	----------
	//	Pre-select OptionGroups containing only one 'available'
	//  option (which is based on 'filters' have already been applied)
	//	----------
	const thisOptionGroupAlreadyHasAFilter = !!filters[groupIndex];
	if (!thisOptionGroupAlreadyHasAFilter && availableOptionValues?.length === 1) {
		// console.log(group_index,available_option_values[0]);	//	Debugging Only
		setFilter(groupIndex, availableOptionValues[0]);
	}

	//	---------------
	//	Render Children
	//	---------------
	const options = allOptionValues.map((_v, i) => {
		// const selected = filters[groupIndex] == _v;
		const doesExist = Helpers.doesOptionExistWithinSelections(
			product,
			groupIndex,
			_v,
			filters
		);
		const isInStock = Helpers.isOptionInStockWithinSelections(
			product,
			groupIndex,
			_v,
			filters,
			availabilityMap
		);

		const available = doesExist && isInStock;

		//	Don't render this option at all if it's not available.
		// if (!available) return null;

		return (
			<option
				// eslint-disable-next-line
				key={i}
				value={_v}
			>
				{_v}
				{available ? '' : ' - n/a'}
			</option>
		);
	});

	const selectedLabel	= filters[groupIndex];

	function handleClick(event) {
		const selectElement = event.target;
		const available = availableOptionValues.indexOf(selectElement.value) > -1;
		const selected = filters[groupIndex] === selectElement.value;
		if (available) {
			setFilter(groupIndex, selected ? null : selectElement.value);
		} else {
			//	Select this option & deselect all other
			//  selected options when clicking a disabled option.
			const resetFilters = {};
			resetFilters[groupIndex] = selectElement.value;
			setFilters(JSON.stringify(resetFilters));
		}
	}

	//	Don't render anything if there are no options to place in the <select> element.
	if (!availableOptionValues.length)	return null;

	const classNames = [
		'pdp-form__option-group',
		!selectedLabel && showErrors ? 'error' : null,
	].join(' ');

	return (
		<div
			className={classNames}
			data-index={groupIndex}
			data-name={option.name.trim()}
			data-handle={option.name.trim().toLowerCase()}
		>
			<div className={`pdp-form__option-group-label`}>
				<span className={'name'}>{`${ option.name }: `}</span>
				<span className={'selected'}>{selectedLabel}</span>
			</div>
			<div className={'select'}>
				<select onChange={handleClick} value={filters[groupIndex] ?? ''} defaultValue={''}>
					<option disabled key={'none'} value={''}>{`Select a ${ option.name.toLowerCase() }`}</option>
					{options}
				</select>
				<svg width={'18'} height={'10'} viewBox={'0 0 18 10'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
					<path d={'M1 1L9 9L17 1'} stroke={'#003C77'} strokeWidth={'1.5'} strokeLinecap={'round'} strokeLinejoin={'round'} />
				</svg>
			</div>
			{!selectedLabel && showErrors && (
				<div className={`pdp-form__option-group-error`}>
					{`Please select a ${ option.name === 'Format' ? 'type' : option.name.toLowerCase() }`}
				</div>
			)}
			{/* <span className={'active_selection'}>
				{selectedLabel ?? `Please select a ${ option.name.toLowerCase() }`}
			</span> */}
		</div>
	);
};

export default OptionGroupAsSelect;
